import { useContext, useEffect, useState } from "react";

import { UserContext } from "@context/user";
import { PAYMENT_MODEL } from "@constants/panel/common";
import useAxios from "@hooks/use-axios";
import { OPS_ENDPOINTS } from "@constants/endpoints";

const usePublisherInvoices = (publisherId) => {
    const { axiosInstance, loading } = useAxios({ base: "ops", initialLoader: true });
    const { opsPaymentModel } = useContext(UserContext);
    const [invoices, setInvoices] = useState([]);
    const [stats, setStats] = useState({ total_invoices: 0, outstanding: 0, paid_to_date: 0 });
    const [detailTarget, setDetailTarget] = useState(null);

    const fetchInvoices = async () => {
        try {
            const res = await axiosInstance.get(OPS_ENDPOINTS.PUBLISHER_INVOICES(publisherId));
            const result = res.data || res;
            setInvoices(result.data || result.items || result.results || []);
            setStats(result.stats || { total_invoices: 0, outstanding: 0, paid_to_date: 0 });
        } catch {
            setInvoices([]);
        }
    };

    useEffect(() => {
        if (publisherId) fetchInvoices();
    }, [publisherId]); // eslint-disable-line react-hooks/exhaustive-deps

    // Under self payout the brand pays the publisher against the invoice itself, so
    // the rows carry no debit note to reference.
    return {
        invoices,
        loading,
        stats,
        detailTarget,
        openInvoice : setDetailTarget,
        closeInvoice: () => setDetailTarget(null),
        isSelfPayout: opsPaymentModel === PAYMENT_MODEL.SELF_PAYOUT
    };
};

export default usePublisherInvoices;
